module.exports = __webpack_public_path__ + "img/writingSeminar_041022_E.72f88805.jpg";